import { IAddressSearchInfo } from "@/domain/entities/address";
import { AddressItem, GeocodeResponse } from "@/types";

export const useUpdateAddress = (
  emitOnUpdateAddress: (address: IAddressSearchInfo) => void
) => {
  const getRoadAddress = (item?: AddressItem) => {
    if (!item) return "";
    const { dongmyun, rest, ri, sido, sigugun } = item.addrdetail;
    const [restNo] = rest.split(" ");
    return `${sido} ${sigugun} ${dongmyun} ${ri} ${restNo}`.replace("  ", " ");
  };

  const createAddress = (response: GeocodeResponse) => {
    const [longitude, latitude] = response?.result?.userquery?.split(",");

    const dongAddress =
      response.result.items.find((item) => !item.isRoadAddress)?.address ?? "";
    const roadAddressItem = response.result.items.find(
      (item) => item.isRoadAddress
    );
    const roadAddress = getRoadAddress(roadAddressItem);

    const roadLand = response?.v2?.results?.find(
      (result: any) => result.name === "roadaddr"
    )?.land;
    const zipNo = roadLand?.addition1?.value ?? "";

    const address: IAddressSearchInfo = {
      zipNo,
      dongAddress,
      dongNo: "",
      roadAddress,
      roadNo: "",
      isUnder: false,
      buildingMainNo: -1,
      buildingSubNo: -1,
      latitude: Number(latitude),
      longitude: Number(longitude),
    };

    return address;
  };

  const updateAddressFromLatLng = (lat: number, lng: number) => {
    const location = new window.naver.maps.LatLng(lat, lng);

    const handleReverseGecodeResult = (status: number, response: any) => {
      if (status !== 200) return;

      const address = createAddress(response);
      emitOnUpdateAddress(address);
    };

    // Reverse Geocoding API 월 300만 건 무료, 300만 건 초과시 건당 0.5원
    window.naver.maps.Service.reverseGeocode(
      { location },
      handleReverseGecodeResult
    );
  };

  let debounceTimer: ReturnType<typeof setTimeout>;

  const debounceUpdateAddress = (lat: number, lng: number) => {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      updateAddressFromLatLng(lat, lng);
    }, 500);
  };

  return { debounceUpdateAddress };
};
